
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Le 25 janvier 2020, on a appris que
`}<a parentName="p" {...{
        "href": "153649343498"
      }}>{`l’Institut Pasteur arrêtait carrément son projet`}</a>{` de vaccin
contre le Covid-19. Il pensait pour sa part utiliser un vaccin contre la
rougeole en y ajoutant des morceaux du coronavirus. Il s’était allié au
laboratoire pharmaceutique MSD (le nom du groupe Merck en-dehors des Etats-Unis
et du Canada). Mais les premiers essais sur des être humains (phase 1) n’ont pas
donné les résultats escomptés: le produit était bien toléré, mais les réponses
immunitaires ont été jugées insuffisantes. L’Institut Pasteur a précisé qu'il
poursuivait ses travaux sur d’autres projets de vaccin contre le Covid.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;